<template>
  <!--訂單支付-->
  <div class="block" v-show="show">
    <img :src="require('@/assets/homeImg/zfcg_icon_huoche@2x.png')" alt="">
    <div style="color:#1E1303;font-size: 24px;margin-top: 38px;margin-bottom: 10px;">
      {{$t('mall_pay_success.pay_success')}}<!-- 支付成功！ -->
    </div>
    <div style="color:#7A7977;">
      {{$t('mall_pay_success.tips')}} <!-- 搜飾盒正在為您準備首飾 -->
    </div>
    <button class="pointer checkOrder" @click="checkOrder">
      {{$t('mall_pay_success.view_order')}} <!-- 查看訂單 -->
    </button>
  </div>
</template>
<script>
  export default {
    name: "PaySuccess",
    data(){
      return{
        show: false,
        status: 'n',
        orderId: '',
      }
    },
    methods:{
      checkOrder() {
        this.$router.push({
          name: 'OrderDetail',
          query: { id: this.orderId }
        })
      },
      getOrderDetail() {
        this.$axios.get('mall_api/order_detail/' + this.orderId, {}).then(res => {
          this.status = res.data.data.is_completed;
          if (this.status === 'y') {
            this.checkOrder();
          } else {
            this.$axios.post('mall_api/trans/purchase_finish', { order_purchase_id: this.orderId }).then(res => {
              this.show = true;
              this.$notify.success({
                message:this.$t('mall_pay_success.pay_success')//'支付成功'
              });
            });
          }
        })
      },
    },
    mounted(){

    },
    created() {
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', function () {
        history.pushState(null, null, document.URL);
      });
      this.orderId = this.$route.query.order_id;
      let status = this.$route.query.status;
      this.$parent.changeTab(3);
      if (status === 'success' && this.orderId) {
        this.getOrderDetail();
      } else {
        this.$router.push({ name: 'NotFound' });
      }
    },
  }
</script>

<style scoped>
  .block {
    text-align: center;
    padding: 80px 0 80px 0;
  }
  .block>img {
    width: 360px;
  }
  .checkOrder {
    width: 120px;
    height: 44px;
    color: white;
    background: #1e1303;
    font-size: 16px;
    margin-top: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/views/viewHK/Order/PaySuccess.vue